import { mapGetters, mapState } from 'vuex';
import moment from 'moment/moment';
import ActionStatus from '@shared/lib/constant/ActionStatus';
import formatterMixin from './formatterMixin';

const serviceMixin = {
  data() {
    return {
      loadingVisitType: false,
      loadingServiceCategory: false,
      loadingCondition: false,
      scheduledStatus: [
        ActionStatus.Reschedule_Request,
        ActionStatus.Scheduled,
        ActionStatus.Cancellation_Pending,
      ],
      closedStatus: [
        ActionStatus.Cancelled,
        ActionStatus.Completed,
        ActionStatus.Resolved,
        ActionStatus.Dismissed,
        ActionStatus.Expired,
      ],
    };
  },
  mixins: [formatterMixin],
  computed: {
    ...mapState({
      loadingServiceRequest: (state) => state.service.loadingServiceRequest,
      loadingLeads: (state) => state.service.loadingLeads,
      loadingJobs: (state) => state.service.loadingJobs,
      loadingDetail: (state) => state.service.loadingDetail,
      actionRequest: (state) => state.service.actionRequest,
      leadDetail: (state) => state.service.leadDetail,
      activeAlertList: (state) => state.service.activeAlertList,
      systemInsightList: (state) => state.service.systemInsightList,
      copyLeadFilters: (state) => state.service.copyLeadFilters,
      tableData: (state) => state.service.tableData,
      sortedCorporation: (state) => state.service.sortedCorporation,
      showServiceBottomSheet: (state) => state.service.showServiceBottomSheet,
      serviceBottomsheetView: (state) => state.service.serviceBottomsheetView,
      showActionModal: (state) => state.service.showActionModal,
      actionModalView: (state) => state.service.actionModalView,
      serviceInfo: (state) => state.service.serviceInfo,
      allPastServices: (state) => state.service.allPastServices,
      confirmedTimeOp: (state) => state.service.confirmedTimeOptions,
      serviceCategoryList: (state) => state.service.serviceCategoryList,
      visitTypeList: (state) => state.service.visitTypeList,
      issueList: (state) => state.service.conditionList,
      allTechnicians: (state) => state.service.allTechnicians,
      processingAction: (state) => state.service.processing,
      activeTab: (state) => state.service.activeTab,
      serviceFilters: (state) => state.service.serviceFilters,
      serviceSummary: (state) => state.service.serviceSummary,
      loadingSummary: (state) => state.service.loadingSummary,
      loadingNotes: (state) => state.service.loadingNotes,
      uploadingInvoice: (state) => state.service.uploadingInvoice,
      jobList: (state) => state.service.jobList,
      showRightSidebar: (state) => state.service.showRightSidebar,
      serviceReference: (state) => state.service.serviceReference,
      customerNoteList: (state) => state.service.customerNoteList,
      pastAlertList: (state) => state.service.pastAlertList,
      selectedNote: (state) => state.service.selectedNote,
      selectedAlert: (state) => state.service.selectedAlert,
      chronicType: (state) => state.service.chronicType,
      customerId: (state) => state.service.customerId,
      isActioned: (state) => state.service.isActioned,
      isNoteActioned: (state) => state.service.isNoteActioned,
      techList: (state) => state.technician.technicians,
      customerBalance: (state) => state.service.customerBalance,
      loadingComfortCredit: (state) => state.customerDetail.loadingComfortCredit,
    }),
    ...mapGetters([
      'isSmacAdmin',
      'adminRole',
      'allBranches',
      'pastAlerts',
      'pastServicesTableData',
    ]),
    ActionStatus() {
      return ActionStatus;
    },
  },
  methods: {
    navigateToProfile(e) {
      e.stopPropagation();
      const profileUrl = this.$router.resolve({
        path: `/member/${this.serviceItem.customerId}`,
      }).href;
      window.open(profileUrl, '_blank');
    },
    getTechOptions(corpId) {
      if (!this.techList && !corpId) {
        return [];
      }
      const filteredList = [];
      this.techList.forEach((tech) => {
        if (tech.corporationId === corpId) {
          filteredList.push({
            value: tech.id,
            label: `${tech.firstName} ${tech.lastName} • ${tech.companyName}`,
          });
        }
      });
      return filteredList;
    },
    async updateDateRangeFilter(value, type) {
      const newFilters = this.serviceFilters.map((fo) => {
        if (fo.key === 'dateCreated' && fo.activeOption.value === 'custom') {
          fo.active = true;
          fo.selectedDateRange = value;
        }
        return fo;
      });
      await this.$store.dispatch('changeServiceValues', [{
        field: 'serviceFilters',
        value: newFilters,
      }]);

      if (type !== 'all-filters') {
        await Promise.all([
          this.$store.dispatch('getAllServiceJobs'),
          this.$store.dispatch('getAllServiceRequest'),
          this.$store.dispatch('getAllLeads'),
          this.$store.dispatch('getServiceSummary'),
        ]);
      }
    },
    changeServiceValues(changes) {
      this.$store.dispatch('changeServiceValues', changes);
    },
    handleAddNote() {
      this.$store.dispatch('changeServiceValue', {
        field: 'selectedNote',
        value: {},
      });
      this.toggleActionModal(true, 'add-note');
    },
    handleNoteView(item, isEdit) {
      this.$store.dispatch('changeServiceValue', {
        field: 'selectedNote',
        value: item,
      });
      if (isEdit) {
        this.toggleActionModal(true, 'edit-note');
      } else {
        this.toggleActionModal(true, 'view-note');
      }
    },
    deleteNote(item) {
      this.$store.dispatch('changeServiceValue', {
        field: 'selectedNote',
        value: item,
      });
      this.toggleActionModal(true, 'delete-confirm');
    },
    isEditable(user, date) {
      const currentAdmin = this.$store.state.admin;
      const {
        email,
      } = currentAdmin;
      return (email === user || this.isSmacAdmin) && moment().subtract(7, 'days').isBefore(date);
    },
    handleRequestAction(modal, status) {
      const actionReq = {
        ...this.serviceItem,
        actionStatus: status,
        actionNote: null,
      };
      const changes = [{
        field: 'serviceInfo',
        value: this.serviceItem,
      }, {
        field: 'showActionModal',
        value: true,
      }, {
        field: 'actionModalView',
        value: modal,
      }, {
        field: 'actionRequest',
        value: actionReq,
      }];
      this.$store.dispatch('changeServiceValues', changes);
    },
    toggleServiceBottomSheet(show, view, item) {
      if (!show) {
        this.$store.dispatch('resetLeadDetail');
        this.$store.dispatch('changeServiceValues', [{
          field: 'showServiceBottomSheet',
          value: false,
        }]);
      } else {
        const changes = [{
          field: 'showServiceBottomSheet',
          value: show,
        }, {
          field: 'serviceBottomsheetView',
          value: view,
        }, {
          field: 'serviceInfo',
          value: item,
        }];
        this.$store.dispatch('changeServiceValues', changes);
      }
    },
    async getTechList() {
      await this.$store.dispatch('getTechnicianList');
    },
    async getServiceCategoryList() {
      try {
        this.loadingServiceCategory = true;
        await this.$store.dispatch('getServiceCategoriesByCorp');
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingServiceCategory = false;
      }
    },
    async getVisitTypeList(category) {
      if (category) {
        try {
          this.loadingVisitType = true;
          await this.$store.dispatch('getVisitTypes', category);
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingVisitType = false;
        }
      }
    },
    async getConditionList(category, type) {
      if (category && type) {
        try {
          this.loadingCondition = true;
          await this.$store.dispatch('getServiceConditions', {
            category,
            visitType: type,
          });
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingCondition = false;
        }
      }
    },
    formatNoteDate(date) {
      return moment(date).format('ll');
    },
    formatTime(time) {
      return moment(time).format('LT');
    },
    addTechnician() {
      const changes = [{
        field: 'showActionModal',
        value: true,
      }, {
        field: 'actionModalView',
        value: 'invite-tech',
      }];
      this.$store.dispatch('changeTechnicianValues', changes);
    },
    toggleActionModal(show, view) {
      if (!show) {
        this.$store.dispatch('changeServiceValues', [{
          field: 'showActionModal',
          value: false,
        }]);
      } else {
        const changes = [{
          field: 'showActionModal',
          value: true,
        }, {
          field: 'actionModalView',
          value: view,
        }];
        this.$store.dispatch('changeServiceValues', changes);
      }
    },
  },
};
export default serviceMixin;
